module.exports = __webpack_public_path__ + "img/zip_08_purpurova.471a335c.png";